export interface PaginationState {
  totalPages?: number;
  currentPage: number;
  pageSize: number;
  totalItems?: number;
  startPage?: number;
  endPage?: number;
  startIndex?: number;
  endInde?: number;
  pages?: number;
  pageItems?: any;
}

export const initialPaginationState: PaginationState = {
  currentPage: 1,
  pageSize: 10
};
